/* eslint-disable no-const-assign */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import useRegistrationContext from "../../../../hooks/useRegistrationContext";
import PhoneInput from "react-phone-input-2";

const Confirmation = () => {
	useEffect(() => {
		// 👇️ scroll to top on page load
		window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
	}, []);

	const { data } = useRegistrationContext();

	const content = (
		<>
			<fieldset className="col-sm-12">
				<h3 style={{ textAlign: "center", fontWeight: 700 }}>
					Confirm Your Information
				</h3>
				<hr />
				<fieldset className="col-sm-12">
					<legend>NDC Membership Status</legend>
					<div className="form-group row">
						<label
							htmlFor="fullname"
							className="col-sm-2 col-form-label"
						>
							NDC Member
						</label>
						<div className="col-sm-2">
							<input
								type="text"
								id="registered_ndc_member"
								readOnly
								style={{
									fontSize: 16,
									fontWeight: "bolder",
									textTransform: "uppercase",
								}}
								value={data.membershipNdcMembership}
								className="form-control"
							/>
						</div>

						<label
							htmlFor="ndc_number"
							className="col-sm-2 col-form-label"
						>
							Membership ID<span>*</span>
						</label>
						<div className="col-sm-2">
							<input
								type="text"
								id="ndc_number"
								readOnly
								style={{
									fontSize: 16,
									fontWeight: "bolder",
									textTransform: "uppercase",
								}}
								value={data.membershipNdcMembershipNumber}
								className="form-control"
							/>
						</div>

						<label
							htmlFor="voter_id_number"
							className="col-sm-2 col-form-label"
						>
							Voter ID
						</label>
						<div className="col-sm-2">
							<input
								type="text"
								id="voter_id_number"
								readOnly
								style={{
									fontSize: 16,
									fontWeight: "bolder",
									textTransform: "uppercase",
								}}
								value={data.membershipVoterIdNumber}
								className="form-control"
							/>
						</div>
					</div>
				</fieldset>
				<hr />
			</fieldset>
			<fieldset className="col-sm-12">
				<fieldset className="col-sm-6">
					<legend>Personal Information</legend>

					<div className="form-group row">
						<label
							htmlFor="title"
							className="col-sm-3 col-form-label"
						>
							Title<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-5">
							<input
								type="text"
								id="title"
								readOnly
								style={{
									fontSize: 16,
									fontWeight: "bolder",
									textTransform: "uppercase",
								}}
								value={data.personalTitle}
								className="form-control"
							/>
						</div>
					</div>
					<div className="form-group row">
						<label
							htmlFor="last_name"
							className="col-sm-3 col-form-label"
						>
							Last Name<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-9">
							<input
								type="text"
								id="last_name"
								value={data.personalLastname}
								readOnly
								style={{
									fontSize: 16,
									fontWeight: "bolder",
									textTransform: "uppercase",
								}}
								className="form-control"
							/>
						</div>
					</div>
					<div className="form-group row">
						<label
							htmlFor="first_name"
							className="col-sm-3 col-form-label"
						>
							First Name<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-9">
							<input
								type="text"
								id="first_name"
								value={data.personalFirstname}
								readOnly
								style={{
									fontSize: 16,
									fontWeight: "bolder",
									textTransform: "uppercase",
								}}
								className="form-control"
							/>
						</div>
					</div>
					<div className="form-group row">
						<label
							htmlFor="middle_name"
							className="col-sm-3 col-form-label"
						>
							Middle Name
						</label>
						<div className="col-sm-9">
							<input
								type="text"
								id="middle_name"
								readOnly
								style={{
									fontSize: 16,
									fontWeight: "bolder",
									textTransform: "uppercase",
								}}
								value={data.personalMiddleName}
								name="middle_name"
								className="form-control"
							/>
						</div>
					</div>
					<div className="form-group row">
						<label
							htmlFor="date_of_birth"
							className="col-sm-3 col-form-label"
						>
							Date of Birth<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-9">
							<input
								type="date"
								id="date_of_birth"
								readOnly
								style={{
									fontSize: 16,
									fontWeight: "bolder",
									textTransform: "uppercase",
								}}
								value={data.personalDateOfBirth}
								className="form-control"
							/>
						</div>
					</div>
					<div className="form-group row">
						<label
							htmlFor="gender"
							className="col-sm-3 col-form-label"
						>
							Gender<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-4">
							<input
								type="text"
								id="gender"
								readOnly
								style={{
									fontSize: 16,
									fontWeight: "bolder",
									textTransform: "uppercase",
								}}
								value={data.personalGender}
								name="gender"
								className="form-control"
							/>
						</div>
					</div>
					<div className="form-group row">
						<label
							htmlFor="marital_status"
							className="col-sm-3 col-form-label"
						>
							Marital Status<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-9">
							<input
								type="text"
								id="marital_status"
								readOnly
								style={{
									fontSize: 16,
									fontWeight: "bolder",
									textTransform: "uppercase",
								}}
								value={data.personalMaritalStatus}
								className="form-control"
							/>
						</div>
					</div>

					<legend>Region & Constituency</legend>
					<div className="form-group row">
						<label
							htmlFor="region"
							className="col-sm-3 col-form-label"
						>
							Region<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-9">
							<input
								type="text"
								id="region"
								readOnly
								style={{
									fontSize: 16,
									fontWeight: "bolder",
									textTransform: "uppercase",
								}}
								value={data.regionsRegionName}
								className="form-control"
							/>
						</div>
					</div>
					<div className="form-group row">
						<label
							htmlFor="constituency"
							className="col-sm-3 col-form-label"
						>
							Constituency<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-9">
							<input
								type="text"
								id="constituency"
								readOnly
								style={{
									fontSize: 16,
									fontWeight: "bolder",
									textTransform: "uppercase",
								}}
								value={data.regionsConstituencyName}
								className="form-control"
							/>
						</div>
					</div>
					<div className="form-group row">
						<label
							htmlFor="branch"
							className="col-sm-3 col-form-label"
						>
							Branch<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-9">
							<input
								type="text"
								id="branch"
								readOnly
								style={{
									fontSize: 16,
									fontWeight: "bolder",
									textTransform: "uppercase",
								}}
								value={data.regionsBranchName}
								className="form-control"
							/>
						</div>
					</div>
					<div className="form-group row">
						<label
							htmlFor="recommended_by"
							className="col-sm-3 col-form-label"
						>
							Recommended By <span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-9">
							<input
								type="text"
								id="recommended_by"
								readOnly
								style={{
									fontSize: 16,
									fontWeight: "bolder",
									textTransform: "uppercase",
								}}
								value={data.regionsRecommendedBy}
								className="form-control"
							/>
						</div>
					</div>
				</fieldset>

				<fieldset className="col-sm-6">
					<legend>Contact Information</legend>
					<div className="form-group row">
						<label className="col-sm-3 col-form-label">
							Mobile Number<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-9">
							<PhoneInput
								type="tel"
								id="mobile_number"
								inputStyle={{
									paddingTop: 16,
									paddingRight: 14,
									paddingBottom: 24,
									paddingLeft: 58,
									fontSize: 16,
									fontWeight: "bolder",
									width: "100%",
									zIndex: 1,
									height: 40,
									backgroundColor: "#F3F6F9",
								}}
								value={data.contactMobileNumber}
								disabled
							/>
						</div>
					</div>
					<div className="form-group row">
						<label
							htmlFor="email"
							className="col-sm-3 col-form-label"
						>
							Email Address<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-9">
							<input
								type="email"
								id="email"
								readOnly
								style={{
									fontSize: 16,
									fontWeight: "bolder",
									textTransform: "uppercase",
								}}
								value={data.contactEmail}
								name="email"
								className="form-control"
							/>
						</div>
					</div>

					<legend>Education Background</legend>
					<div className="form-group row">
						<label
							htmlFor="last_tertiary_institution"
							className="col-sm-3 col-form-label"
						>
							Last Tertiary Institution
							<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-9">
							<input
								type="text"
								id="last_tertiary_institution"
								readOnly
								style={{
									fontSize: 16,
									fontWeight: "bolder",
									textTransform: "uppercase",
								}}
								value={data.educationLastTertiaryInstitution}
								className="form-control"
							/>
						</div>
					</div>
					<div className="form-group row">
						<label
							htmlFor="qualification_type"
							className="col-sm-3 col-form-label"
						>
							Last Qualification Type
							<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-9">
							<input
								type="text"
								id="qualification_type"
								readOnly
								style={{
									fontSize: 16,
									fontWeight: "bolder",
									textTransform: "uppercase",
								}}
								value={data.educationQualificationType}
								className="form-control"
							/>
						</div>
					</div>
					<div className="form-group row">
						<label
							htmlFor="qualification"
							className="col-sm-3 col-form-label"
						>
							Qualification<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-9">
							<input
								type="text"
								id="qualification"
								readOnly
								style={{
									fontSize: 16,
									fontWeight: "bolder",
									textTransform: "uppercase",
								}}
								value={data.educationQualification}
								className="form-control"
							/>
						</div>
					</div>
				</fieldset>
				<fieldset className="col-sm-6">
					<legend>Profession</legend>
					<div className="form-group row">
						<label
							htmlFor="profession"
							className="col-sm-3 col-form-label"
						>
							Profession<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-9">
							<input
								type="text"
								id="profession"
								readOnly
								style={{
									fontSize: 16,
									fontWeight: "bolder",
									textTransform: "uppercase",
								}}
								value={data.professionProfession}
								className="form-control"
							/>
						</div>
					</div>
					<div className="form-group row">
						<label
							htmlFor="occupations"
							className="col-sm-3 col-form-label"
						>
							Occupations<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-9">
							<input
								type="text"
								id="occupations"
								readOnly
								style={{
									fontSize: 16,
									fontWeight: "bolder",
									textTransform: "uppercase",
								}}
								value={data.professionOccupation}
								className="form-control"
							/>
						</div>
					</div>
					<div className="form-group row">
						<label
							htmlFor="employment_type"
							className="col-sm-3 col-form-label"
						>
							Employment Type<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-9">
							<input
								type="text"
								id="employment_type"
								readOnly
								style={{
									fontSize: 16,
									fontWeight: "bolder",
									textTransform: "uppercase",
								}}
								value={data.professionEmploymentType}
								className="form-control"
							/>
						</div>
					</div>
					<div className="form-group row">
						<label
							htmlFor="current_employment"
							className="col-sm-3 col-form-label"
						>
							Current Employment <span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-9">
							<input
								type="text"
								id="current_employment"
								readOnly
								style={{
									fontSize: 16,
									fontWeight: "bolder",
									textTransform: "uppercase",
								}}
								value={data.professionCurrentEmployment}
								className="form-control"
							/>
						</div>
					</div>
				</fieldset>
			</fieldset>
		</>
	);
	return content;
};
export default Confirmation;
